module.exports = __webpack_public_path__ + "static/media/gm.814fdc51.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gm.svg
// module id = 657
// module chunks = 0